import { useCallback, useRef, useState } from "react";

const isOverflowing = (element: HTMLElement) => element.scrollWidth > element.offsetWidth;

export const usePropertyTooltip = (alwaysOpen: boolean) => {
	const textRef = useRef<HTMLSpanElement>(null);
	const [open, setOpen] = useState(false);
	const [overflowing, setOverflowing] = useState(false);

	const onOpenChange = useCallback(
		(newOpen: boolean) => {
			if (!newOpen) return setOpen(false);
			const textOverflows = !!textRef.current && isOverflowing(textRef.current);
			setOverflowing(textOverflows);
			setOpen(alwaysOpen || textOverflows);
		},
		[alwaysOpen],
	);

	return { textRef, open, overflowing, onOpenChange };
};
